export default __webpack_public_path__ + "static/media/pexels-rachel-claire-4846101.471955c8.jpg";